module.exports = __webpack_public_path__ + "static/img/jinbi.cf6963b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jinbi.png
// module id = Sa3d
// module chunks = 23